import { v4 } from 'uuid';

export interface GenIdOptions {
  /** 指定生成 id 的长度，默认为 6 */
  length?: number;
  /** id 前缀 */
  prefix?: string;
  /** id 后缀 */
  suffix?: string;
  /** 连接符 */
  separator?: string;
}
/**
 * 生成一个随机 id
 * @description 生成一个随机 id, 默认长度为 6 位, 可以指定前缀和后缀
 * @param options 选项
 * @param options.length 指定生成 id 的长度，默认为 6
 * @param options.prefix id 前缀
 * @param options.suffix id 后缀
 * @param options.separator 连接符
 * @returns 随机 id
 * @example
 * ```ts
 * genId() // 123456
 * genId({ length: 8 }) // 12345678
 * genId({ prefix: 'prefix' }) // prefix123456
 * genId({ suffix: 'suffix' }) // 123456suffix
 * genId({ prefix: 'prefix', suffix: 'suffix' }) // prefix123456suffix
 * genId({ prefix: 'prefix', suffix: 'suffix', separator: '_' }) // prefix_123456_suffix
 * genId({ prefix: 'prefix', suffix: 'suffix', separator: '-' }) // prefix-123456-suffix
 * ```
 */
export const genId = (options?: GenIdOptions): string => {
  const len = options?.length ?? 6;
  const prefix = options?.prefix ?? '';
  const suffix = options?.suffix ?? '';
  const separator = options?.separator ?? '';
  const prefixSeparator = prefix ? `${prefix}${separator}` : '';
  const suffixSeparator = suffix ? `${separator}${suffix}` : '';
  const id = v4().replace(/-/g, '').substring(0, len);

  return `${prefixSeparator}${id}${suffixSeparator}`;
};
